import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import auth from '@/plugins/auth'
import http, { setInterceptorHooks } from '@/api/http'
import moment from 'moment'
import { yandexMetrika } from './services/yandexMetrika'
import { sendDeferredGoals, trackSiteVisit } from '@/services/metrikaGoals'
import { useAuthStore } from '@/stores/auth'
import { useCommonStore } from '@/stores/common'
import { useGenerationStore } from '@/stores/generation'
import AppConfig from '@/config'
import { handleLimitExceeded } from '@/services/limitExceeded'
import { ensureGuestId } from '@/utils/guestId'
import '@tokens'
import './resources/scss/tokens/sizing.scss'
import './resources/scss/style.scss'

const pinia = createPinia()

const app = createApp(App)
app.provide('moment', moment)

app.use(http)
app.use(pinia)

setInterceptorHooks({
	// В internal-режиме 401 не должен никуда уводить и не должен разлогинивать —
	// ошибка просто пробрасывается в вызывающий код.
	onUnauthorized: () => {
		if (AppConfig.authMode === 'internal') return
		return useAuthStore().logout()
	},
	onNetworkError: () => useCommonStore().openInternetErrorDialog(),
	onLimitExceeded: handleLimitExceeded,
	isPollingActive: () => useGenerationStore().hasActiveTasks()
})

app.use(router)
app.use(auth)

// Гостевая cookie должна существовать до первого запроса к API (fetchTopics в App.vue).
ensureGuestId()

yandexMetrika.init()
// Сначала цели, отложенные прошлой страницей перед перезагрузкой (вход), потом визит.
sendDeferredGoals()
trackSiteVisit()

app.mount('#app')
